import ChrisReadinessActivity from "@/components/landing/chris/ChrisReadinessActivity";

// DEV-ONLY (Phase C1, 2026-06): Reproduzierbare visuelle/geometrische
// Verifikation der Chris-Readiness-Aktivität in ALLEN echten Zuständen
// (RUNNING/BLOCKED/READY) + Reduced-Motion — OHNE echten, kostenpflichtigen
// KI-/Bildlauf (Standard §26 / Auftrag §20/§21). Nur registriert, wenn
// isDevPreviewEnabled() (localhost / *.preview.emergentagent.com).
//
// Query-Parameter (optional):
//   status=running|blocked|ready   nur EINEN Zustand rendern (z. B. für den
//                                   Langzeittest über mehrere Bewegungszyklen)
//   reduced=1                       erzwingt den Reduced-Motion-Zweig

// Kompakter Nachbau des realen ReadinessAmpel-Kontexts (Welt.jsx) — reine
// Anzeige, keine Backend-/Fachlogik.
const HEADLINE = {
  running: "Deine Dokumentationswelt wird gerade fertiggestellt.",
  blocked: "Die Welt kann noch nicht freigegeben werden.",
  ready: "Die Welt ist vollständig und kann freigegeben werden.",
};
const DOT = {
  running: "bg-amber-500",
  blocked: "bg-red-500",
  ready: "bg-emerald-500",
};

function StateBlock({ status, forceReduced }) {
  return (
    <div
      className="w-full rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm"
      data-testid={`welt-chris-dev-block-${status}`}
    >
      <div className="flex items-center gap-2 flex-wrap">
        <span className={`inline-block h-2.5 w-2.5 rounded-full ${DOT[status]}`} />
        <span className="text-slate-800">{HEADLINE[status]}</span>
      </div>
      {status === "running" && (
        <p className="mt-1 text-xs text-slate-500">
          Bilder, Dokumente und Freigabeprüfung werden automatisch vorbereitet.
        </p>
      )}
      <ChrisReadinessActivity status={status} forceReduced={forceReduced} />
      {status === "blocked" && (
        <ul className="mt-2 space-y-1 text-slate-600 list-disc list-inside">
          <li>V4a: 1 Lehrbild existiert nicht physisch im Speicher.</li>
          <li>V3: 1 Lehrbild im Fehlerzustand.</li>
        </ul>
      )}
    </div>
  );
}

export default function WeltChrisDevPreview() {
  const params = new URLSearchParams(window.location.search);
  const single = params.get("status");
  const reduced = params.get("reduced") === "1";
  const states =
    single === "running" || single === "blocked" || single === "ready"
      ? [single]
      : ["running", "blocked", "ready"];

  return (
    <div
      style={{ maxWidth: 560, margin: "0 auto", padding: 24 }}
      data-testid="welt-chris-dev"
      data-reduced={reduced ? "1" : "0"}
    >
      <h1 style={{ fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>
        Chris · Dokumentenwelt Readiness (DEV)
      </h1>
      <p style={{ color: "#64748b", fontSize: 13, marginBottom: 20 }}>
        {reduced ? "Reduced-Motion erzwungen. " : ""}
        Backendstatus ist alleinige Wahrheit — hier nur simulierte Zustände.
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        {states.map((s) => (
          <div key={s}>
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: 0.5,
                color: "#94a3b8",
                marginBottom: 6,
              }}
            >
              {s}
            </div>
            <StateBlock status={s} forceReduced={reduced} />
          </div>
        ))}
      </div>
    </div>
  );
}
